import classNames from 'classnames';
import Reward from '../../../../baseComponents/gui/reward/Reward';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';

export default function RewardComponent({ className, modifier, value, type, mod }) {
  return (
    <div
      className={classNames(
        'universal-modal__reward',
        className,
        ...combineModifiers('universal-modal__reward', modifier),
      )}
    >
      <Reward type={type} mod={mod} value={value} />
    </div>
  );
}
